import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import type {RootState} from '../redux/store';
// Define a type for the slice state

interface CounterState {
  tourGif: boolean;
}

// Define the initial state using that type
const initialState: CounterState = {
  tourGif: false,
};
export const tourGuideSlice = createSlice({
  name: 'tourguide',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    setTourGuide: (state, action: PayloadAction<boolean>) => {
      //console.log('payload is ', action.payload);
      state.tourGif = action.payload;
    },
  },
});

export const {setTourGuide} = tourGuideSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const tourGuide = (state: RootState): boolean =>
  state.tourGuideSlice.tourGif;

//export type State = ReturnType<typeof >;

export default tourGuideSlice.reducer;
